export default __webpack_public_path__ + "static/media/solar-1.f7a0bd8d.jpg";